import { render } from "./MbHomeView.vue?vue&type=template&id=1437b2a2&scoped=true"
import script from "./MbHomeView.vue?vue&type=script&lang=js"
export * from "./MbHomeView.vue?vue&type=script&lang=js"

import "./MbHomeView.vue?vue&type=style&index=0&id=1437b2a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1437b2a2"]])

export default __exports__